import {Component, OnInit} from '@angular/core';
import {Trabalho} from "../trabalho/trabalho";
import {AcessoService} from "../acesso/acesso.service";
import {TrabalhoService} from "../trabalho/trabalho.service";
import {AppComponent} from "../app.component";
import {Router} from "@angular/router";
import {AvaliacaoService} from "../avaliacao/avaliacao.service";
import {Usuario} from "../usuario/usuario";


declare var jQuery: any;

@Component({
    selector: 'app-avaliacao-list',
    templateUrl: './avaliacao-list.component.html',
    styleUrls: ['./avaliacao-list.component.css'],
    providers: [
        TrabalhoService,
        AcessoService,
        AvaliacaoService
    ]
})
export class AvaliacaoListComponent extends AppComponent implements OnInit {
    trabalhos: Trabalho[];
    aplicacao: AppComponent;
    usuarios_pareceristas: Usuario[];
    nome=sessionStorage.getItem("nome");

    getTrabalhosByParecerista(){
		this.spinnerService.show();
        this.trabalhoService.getTrabalhosByParecerista(false).then(trabalho => { 
			this.setTrabalhos(trabalho);
			this.spinnerService.hide();
		});			
		this.getUsersParecer();
	}

    getTrabalhos() {
		this.spinnerService.show();
        this.trabalhoService.getTrabalhos(false).then(trabalho => {
			this.setTrabalhos(trabalho);
			this.spinnerService.hide();
		});	
        this.getUsersParecer();
    }
	
	setTrabalhos(trabalhos: Trabalho[]): void {
		let trocou: boolean = true;
		let tamanho: number = trabalhos.length;
		let i: number;
		let trabAux: Trabalho;
		
		while (trocou) {
			trocou = false;
			for (i = 0; i < (tamanho - 1); i++) {
				if (trabalhos[i].evento_id < trabalhos[i + 1].evento_id 
				 || (trabalhos[i].evento_id == trabalhos[i + 1].evento_id && trabalhos[i].orcamento > trabalhos[i + 1].orcamento)
				 || (trabalhos[i].evento_id == trabalhos[i + 1].evento_id && trabalhos[i].orcamento == trabalhos[i + 1].orcamento 
				  && trabalhos[i].nota > trabalhos[i + 1].nota)) {
					trocou = true;
                    break;
				}
			}
			if (trocou) {
				trabAux = trabalhos[i];
				trabalhos[i] = trabalhos[i + 1];
				trabalhos[i + 1] = trabAux;
			}
		} 
		this.trabalhos = trabalhos;
	}

    ngOnInit() {
        if (!this.islogged()) {
            this.router.navigateByUrl('acesso');
        } else if (this.isAdmin()) {
            this.getTrabalhos();
        } else {
            if (this.isParecerista()) {
                this.getTrabalhosByParecerista();
            } else {
                this.router.navigateByUrl('acesso');
            }
        }
    }

    getUsersParecer(){
        this.avaliacaoService.getparecerista().then(usuario => {
			this.usuarios_pareceristas = usuario;
		});
    }

    show(id) {
        window.open("/trabalho-detail/" + id, "_self");
    }

    enviar(trabalho: Trabalho, acao: string): void {
        this.avaliacaoService.enviarEmail(trabalho, acao).then(response =>
            this.redirect(response, trabalho.id));
    }

    redirect(resp, trab_id) {

        if (resp.status == 200) {
            this.trabalhos.forEach(function (item, key) {
                if (item.id == trab_id) {
                    item.send_status = "Enviado";
                    jQuery("#send_status" + trab_id).text(item.send_status);
                }
            })

        }
    }

    save_parecerista(trab_id, user_id, indice: number){
		this.spinnerService.show();
        let data = new Object();
        data['trab_id'] = trab_id;
        data['user_id'] = user_id;
		data['indice'] = indice;
        this.avaliacaoService.setParecerista(data).then();

    }

    save_grupo(trab_id,grupo){
		this.spinnerService.show();
        let data = new Object();
        data['trab_id'] = trab_id;
        data['grupo'] = grupo;
        this.avaliacaoService.setGrupo(data).then();

    }
	
	nome_parecerista(parecerista_id: number): string {
		let pareceristas: Usuario[] = this.usuarios_pareceristas;
		let i: number = pareceristas.length;
		
		while (--i >= 0)
			if (pareceristas[i].id == parecerista_id)
				return pareceristas[i].nome;
		return "";
	}
	
    delete(id){
        let del = confirm("Você deseja deletar esse trabalho?");
        let data = new Object();
        data['id']=id;
        if(del){
            this.trabalhoService.del(data).then(
                () => this.del_line(id)
                // () => window.location.reload()
            );
        }
    }
    del_line(id){
        console.log(id);
        jQuery('#trab'+id).remove();
    }

	avaliado(trabalho: any, parecerista_id: number): boolean {
		let avaliadores: number[] = trabalho.avaliadores;
		if (avaliadores.length > 0 && avaliadores[0] == parecerista_id) 
			return true;
		if (avaliadores.length > 1 && avaliadores[1] == parecerista_id) 	
			return true;
		return false;
	}
	
	exportar() {
		this.avaliacaoService.exportar(this.trabalhos);
	}
}



// WEBPACK FOOTER //
// ./src/app/avaliacao-list/avaliacao-list.component.ts